import { deleteApiChatBotDataDisconnectEmbeddingCollection, EmbeddingCollectionConfig, getGetApiChatBotDataGetQueryKey, useGetApiEmbeddingCollectionGet } from "@/API";
import { ActionIcon, Button, Group, LoadingOverlay, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import { IconDatabase, IconLinkOff, IconTrash } from "@tabler/icons-react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";

export function ChatBotEmbeddingCollectionEditItem(props: { workspaceId: string, chatBotDataId: string, embeddingCollectionId: string }) {
    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const collection = useGetApiEmbeddingCollectionGet({ workspaceId: props.workspaceId, id: props.embeddingCollectionId })
    const isExist = !!collection.data?.data
    return <>
        <Group gap={5} pos="relative">
            <LoadingOverlay visible={collection.isFetching} zIndex={1000} loaderProps={{ type: "dots" }} />
            <Button color={`${isExist ? "" : "yellow"}`} variant="light" size="compact-sm" radius="xl" onClick={() => {
                if (isExist)
                    navigate({
                        to: "/workspace/$workspaceId/embeddingCollection/$embeddingCollectionId", params: {
                            workspaceId: props.workspaceId,
                            embeddingCollectionId: props.embeddingCollectionId ?? ""
                        }
                    })
                else
                    notifications.show({ message: "資料庫不存在:" + props.embeddingCollectionId, color: "yellow" })
            }}>
                {isExist ? collection.data?.data.name : `${props.embeddingCollectionId}(資料庫不存在)`}
            </Button>
            <ActionIcon variant="subtle" color="red" onClick={() => {
                modals.openConfirmModal({
                    title: '解除資料庫連結',
                    children: (
                        <Text size="sm">
                            是否要解除連結(不會刪除資料庫)資料庫"{collection.data?.data.name}"
                        </Text>
                    ),
                    labels: { confirm: '確定', cancel: "取消" },
                    confirmProps: { color: 'red' },
                    onConfirm: async () => {
                        try {
                            await deleteApiChatBotDataDisconnectEmbeddingCollection({
                                workspaceId: props.workspaceId,
                                id: props.chatBotDataId,
                                embeddingCollectionId: props.embeddingCollectionId
                            })
                            queryClient.invalidateQueries({
                                queryKey: getGetApiChatBotDataGetQueryKey({
                                    id: props.chatBotDataId
                                })
                            })
                            notifications.show({ message: "解除連結成功" })

                        } catch (e) {
                            notifications.show({ message: "解除連結失敗", color: "red" })

                        }
                    },
                });
            }}>
                <IconLinkOff style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
        </Group>
    </>
}